import { Component, OnInit, Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { AccountService } from '../../../../../app/services/account.service';
import { DialogAbstractComponent } from '../../../../../app/shared/dialogs/dialog.class';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss'],
})
export class DisclaimerComponent extends DialogAbstractComponent implements OnInit {
  // addClientFG: FormGroup;
  constructor(injector: Injector, private accountService: AccountService, private router: Router, private fb: FormBuilder) {
    super(injector);
  }

  ngOnInit() {}

  async accept() {
    await this.accountService.updateDiscalimer({ accept: true });
    this.closeDialog();
  }

  async close() {
    let currentUser = await this.accountService.currentUserAsync();
    this.router.navigate([`/dashboard`], { queryParams: { uid: `${currentUser.id}` } });
    this.closeDialog();
  }
}
